module.exports = __webpack_public_path__ + "ab2.no2.2f8d4831.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/ab2.no2.jpg
// module id = SVYB
// module chunks = 0